import axios from "axios";

/**
 * Fetches the user profile picture from the cloud
 * @param {String} bearer The bearer token for the request 
 * @returns The user profile picture response
 */
export const fetchProfilePicture = async (bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_PROFILE_PICTURE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
